(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-announcement')) {
    customElements.define(
      'nc-announcement',
      class extends HTMLElement {
        interval = 5000;

        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('.nc-announcement__item'));
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.paused = false;
          this.selected = false;
          this.show(0);

          this.onEnter = () => this.pause();
          this.onLeave = () => this.resume();
          this.onVisibility = () => (document.hidden ? this.stop() : this.start());
          this.onSelect = (event) => {
            this.selected = true;
            this.stop();
            this.show(this.items.indexOf(event.target.closest('.nc-announcement__item')));
          };
          this.onDeselect = () => {
            this.selected = false;
            this.start();
          };

          this.addEventListener('mouseenter', this.onEnter);
          this.addEventListener('mouseleave', this.onLeave);
          this.addEventListener('focusin', this.onEnter);
          this.addEventListener('focusout', this.onLeave);
          this.addEventListener('shopify:block:select', this.onSelect);
          this.addEventListener('shopify:block:deselect', this.onDeselect);
          document.addEventListener('visibilitychange', this.onVisibility);
          this.motion.addEventListener('change', this.onVisibility);
          this.start();
        }

        disconnectedCallback() {
          this.stop();
          document.removeEventListener('visibilitychange', this.onVisibility);
          this.motion.removeEventListener('change', this.onVisibility);
        }

        pause() {
          this.paused = true;
          this.stop();
        }

        resume() {
          this.paused = false;
          this.start();
        }

        start() {
          this.stop();
          if (this.items.length < 2 || this.motion.matches || this.paused || this.selected) return;
          this.timer = setInterval(() => this.show((this.index + 1) % this.items.length), this.interval);
        }

        stop() {
          clearInterval(this.timer);
        }

        show(index) {
          if (index < 0) return;
          this.index = index;
          this.items.forEach((item, i) => {
            const active = i === index;
            item.classList.toggle('is-active', active);
            item.toggleAttribute('inert', !active);
            item.setAttribute('aria-hidden', String(!active));
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('nc-cart-items')) {
    customElements.define(
      'nc-cart-items',
      class extends HTMLElement {
        connectedCallback() {
          this.timers = new Map();
          this.addEventListener('change', this.onChange);
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          for (const timer of this.timers.values()) clearTimeout(timer);
        }

        onChange = (event) => {
          const input = event.target.closest('input[type="number"]');
          const line = event.target.closest('[data-cart-line]');
          if (!input || !line) return;
          this.schedule(line.dataset.key, Number(input.value));
        };

        onClick = (event) => {
          const remove = event.target.closest('[data-cart-remove]');
          if (!remove) return;
          event.preventDefault();
          const line = remove.closest('[data-cart-line]');
          if (line) this.schedule(line.dataset.key, 0, true);
        };

        schedule(key, quantity, immediate) {
          clearTimeout(this.timers.get(key));
          const run = () => {
            this.timers.delete(key);
            this.change(key, quantity);
          };
          if (immediate) run();
          else this.timers.set(key, setTimeout(run, 400));
        }

        async change(key, quantity) {
          const response = await fetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: this.dataset.sections }),
          });
          const cart = await response.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sections: cart.sections } }));
        }
      },
    );
  }

  if (!customElements.get('nc-cart-drawer')) {
    customElements.define(
      'nc-cart-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.onOpen = () => this.querySelector('nc-drawer')?.open();
          this.onUpdated = (event) => {
            // Section groups prefix `section.id` (`sections--123__cart-drawer`),
            // while add-to-cart requests the bare `cart-drawer` key.
            const rendered = event.detail?.sections;
            const html = rendered?.[this.dataset.sectionId] || rendered?.[this.dataset.sectionId.split('__').pop()];
            if (!html) return;
            const nextPanel = new DOMParser().parseFromString(html, 'text/html').querySelector('.nc-drawer__panel');
            const panel = this.querySelector('.nc-drawer__panel');
            if (nextPanel && panel) panel.replaceWith(nextPanel);
          };
          document.addEventListener('cart:open', this.onOpen);
          document.addEventListener('cart:updated', this.onUpdated);
          this.addEventListener('input', this.onNoteInput);
          this.addEventListener('click', this.onUpsellAdd);
        }

        disconnectedCallback() {
          document.removeEventListener('cart:open', this.onOpen);
          document.removeEventListener('cart:updated', this.onUpdated);
          clearTimeout(this.noteTimer);
        }

        onNoteInput = (event) => {
          const textarea = event.target.closest('[data-cart-note]');
          if (!textarea) return;
          clearTimeout(this.noteTimer);
          this.noteTimer = setTimeout(() => {
            fetch(this.dataset.updateUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: textarea.value }),
            });
          }, 500);
        };

        onUpsellAdd = (event) => {
          const button = event.target.closest('[data-cart-upsell-add]');
          if (!button || button.disabled) return;
          button.disabled = true;

          fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: button.dataset.cartUpsellAdd, quantity: 1 }],
              sections: this.dataset.sectionId,
            }),
          })
            .then((response) => response.json())
            .then(async (data) => {
              // The add response is not a cart (no item_count), so read the cart for the header badge.
              const cart = await fetch(this.dataset.cartUrl).then((response) => response.json());
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sections: data.sections } }));
            })
            .finally(() => {
              button.disabled = false;
            });
        };
      },
    );
  }

  if (!customElements.get('nc-cart-upsell')) {
    customElements.define(
      'nc-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.recommendationsUrl === undefined) return;
          const list = this.querySelector('[data-cart-upsell-list]');
          const url = `${this.dataset.recommendationsUrl}?section_id=${this.dataset.sectionId}&product_id=${this.dataset.productId}&limit=3`;

          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-upsell-list]');
              if (next && next.children.length > 0) {
                list.replaceWith(next);
                this.hidden = false;
              }
            })
            .catch(() => {
              this.hidden = true;
            });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-cart-page')) {
    customElements.define(
      'nc-cart-page',
      class extends HTMLElement {
        connectedCallback() {
          this.onUpdated = (event) => {
            const html = event.detail?.sections?.[this.dataset.sectionId];
            if (!html) return;
            const nextPanel = new DOMParser().parseFromString(html, 'text/html').querySelector('.nc-cart-page__panel');
            const panel = this.querySelector('.nc-cart-page__panel');
            if (nextPanel && panel) panel.replaceWith(nextPanel);
          };
          document.addEventListener('cart:updated', this.onUpdated);
          this.addEventListener('input', this.onNoteInput);
        }

        disconnectedCallback() {
          document.removeEventListener('cart:updated', this.onUpdated);
          clearTimeout(this.noteTimer);
        }

        onNoteInput = (event) => {
          const textarea = event.target.closest('[data-cart-note]');
          if (!textarea) return;
          clearTimeout(this.noteTimer);
          this.noteTimer = setTimeout(() => {
            fetch(this.dataset.updateUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: textarea.value }),
            });
          }, 500);
        };
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-slider')) {
    customElements.define(
      'nc-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.nc-slider');
          this.prevButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');

          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.sync());
          };
          this.onResize = () => this.sync();

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
          this.nextButton?.addEventListener('click', () => this.scrollByCard(1));

          this.sync();
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          window.removeEventListener('resize', this.onResize);
        }

        scrollByCard(direction) {
          const card = this.track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = (card.getBoundingClientRect().width + gap) * direction;
          this.track.scrollBy({ left: distance, behavior: 'smooth' });
        }

        sync() {
          const max = this.track.scrollWidth - this.track.clientWidth - 1;
          this.prevButton?.toggleAttribute('disabled', this.track.scrollLeft <= 0);
          this.nextButton?.toggleAttribute('disabled', this.track.scrollLeft >= max);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('nc-facets')) {
    class NcFacets extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-enhanced');
        this.sectionId = this.dataset.sectionId;
        this.status = document.createElement('div');
        this.status.className = 'visually-hidden';
        this.status.setAttribute('role', 'status');
        this.before(this.status);

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onPopState = () => this.update(window.location.href, { push: false });

        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.addEventListener('click', this.onClick);
        window.addEventListener('popstate', this.onPopState);
      }

      disconnectedCallback() {
        window.removeEventListener('popstate', this.onPopState);
        this.status?.remove();
      }

      urlFor(form) {
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (value !== '') params.append(key, value);
        });
        const url = new URL(form.action, window.location.href);
        url.search = params.toString();
        return url.toString();
      }

      onChange(event) {
        const form = event.target.form;
        if (!form || !form.hasAttribute('data-facets-form') || form.hasAttribute('data-facets-drawer')) return;
        this.update(this.urlFor(form));
      }

      onSubmit(event) {
        const form = event.target.closest('[data-facets-form]');
        if (!form) return;
        event.preventDefault();
        this.update(this.urlFor(form));
      }

      onClick(event) {
        const link = event.target.closest('a[data-facet-link], .nc-pagination a');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        this.update(link.href, { scroll: link.closest('.nc-pagination') !== null });
      }

      async update(url, { push = true, scroll = false } = {}) {
        this.controller?.abort();
        this.controller = new AbortController();
        this.setAttribute('aria-busy', 'true');

        const requestUrl = new URL(url, window.location.href);
        requestUrl.searchParams.set('section_id', this.sectionId);
        const focusedId = document.activeElement?.id;

        try {
          const response = await fetch(requestUrl, { signal: this.controller.signal });
          if (!response.ok) throw new Error(response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('nc-facets');
          if (!next) throw new Error('missing section');

          this.querySelector('dialog[open]')?.close();
          this.innerHTML = next.innerHTML;
          if (push) window.history.pushState({}, '', url);
          this.status.textContent = this.querySelector('[data-facets-count]')?.textContent ?? '';

          if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (focusedId) document.getElementById(focusedId)?.focus({ preventScroll: true });
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.href = url;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('nc-facets', NcFacets);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-contact-error]').forEach((el) => el.focus());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-tabs')) {
    customElements.define(
      'nc-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('.nc-tab'));
          this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

          // A single panel needs no tab machinery, and marking it enhanced would
          // hide every panel: `nc-tabs.is-enhanced .nc-tab-panel { display: none }`
          // only re-shows the panel that carries `is-active`.
          if (this.tabs.length < 2) return;

          this.classList.add('is-enhanced');

          this.onClick = this.onClick.bind(this);
          this.addEventListener('click', this.onClick);

          const initialPanel = this.panels.find((panel) => '#' + panel.id === window.location.hash) || this.panels[0];
          const initialTab =
            this.tabs.find((tab) => tab.getAttribute('aria-controls') === initialPanel?.id) || this.tabs[0];
          this.activate(initialTab, { push: false });
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        onClick(event) {
          const tab = event.target.closest('.nc-tab');
          if (!tab || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
          event.preventDefault();
          this.activate(tab);
        }

        activate(tab, { push = true } = {}) {
          if (!tab) return;
          const panelId = tab.getAttribute('aria-controls');

          this.tabs.forEach((candidate) => {
            const active = candidate === tab;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          this.panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.id === panelId);
          });

          if (push) window.history.replaceState({}, '', tab.getAttribute('href'));
        }
      },
    );
  }

  if (!customElements.get('nc-slider')) {
    customElements.define(
      'nc-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this;
          this.prevButton = this.parentElement.querySelector('[data-prev]');
          this.nextButton = this.parentElement.querySelector('[data-next]');

          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.sync());
          };
          this.onResize = () => this.sync();

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
          this.nextButton?.addEventListener('click', () => this.scrollByCard(1));

          this.sync();
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          window.removeEventListener('resize', this.onResize);
        }

        scrollByCard(direction) {
          const card = this.track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = (card.getBoundingClientRect().width + gap) * direction;
          this.track.scrollBy({ left: distance, behavior: 'smooth' });
        }

        sync() {
          const max = this.track.scrollWidth - this.track.clientWidth - 1;
          this.prevButton?.toggleAttribute('disabled', this.track.scrollLeft <= 0);
          this.nextButton?.toggleAttribute('disabled', this.track.scrollLeft >= max);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('nc-back-to-top')) {
    customElements.define(
      'nc-back-to-top',
      class extends HTMLElement {
        threshold = 600;

        connectedCallback() {
          this.button = this.querySelector('button');
          this.onScroll = () => {
            this.button.hidden = window.scrollY < this.threshold;
          };
          this.onClick = () => {
            const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
            document.getElementById('MainContent')?.focus({ preventScroll: true });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.button.addEventListener('click', this.onClick);
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          this.button.removeEventListener('click', this.onClick);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('nc-header')) {
    customElements.define(
      'nc-header',
      class extends HTMLElement {
        connectedCallback() {
          this.wrapper = this.closest('.shopify-section');
          this.items = Array.from(this.querySelectorAll('[data-menu-item]'));
          this.lastY = window.scrollY;
          this.ticking = false;

          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
          this.addEventListener('focusout', this.onFocusOut);
          this.addEventListener('shopify:block:select', this.onBlockSelect);
          this.addEventListener('shopify:block:deselect', this.closeAll);
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('cart:updated', this.onCartUpdated);
          window.addEventListener('scroll', this.onScroll, { passive: true });

          this.desktopQuery = window.matchMedia('(min-width: 1150px)');
          this.desktopQuery.addEventListener('change', this.onBreakpoint);

          for (const item of this.items) {
            item.addEventListener('mouseenter', this.onMouseEnter);
            item.addEventListener('mouseleave', this.onMouseLeave);
          }
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('cart:updated', this.onCartUpdated);
          window.removeEventListener('scroll', this.onScroll);
          this.desktopQuery?.removeEventListener('change', this.onBreakpoint);
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.wrapper?.classList.remove('is-header-hidden');
        }

        get hoverable() {
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }

        toggleOf(item) {
          return item.querySelector(':scope > .nc-menu__toggle');
        }

        open(item) {
          for (const other of this.items) {
            if (other !== item) this.close(other);
          }
          this.toggleOf(item)?.setAttribute('aria-expanded', 'true');
        }

        close(item) {
          this.toggleOf(item)?.setAttribute('aria-expanded', 'false');
        }

        closeAll = () => {
          for (const item of this.items) this.close(item);
        };

        onMouseEnter = (event) => {
          if (!this.hoverable) return;
          clearTimeout(this.closeTimer);
          if (!this.toggleOf(event.currentTarget)) return;
          const item = event.currentTarget;
          clearTimeout(this.openTimer);
          if (this.toggleOf(item).getAttribute('aria-expanded') === 'true') return;
          this.openTimer = setTimeout(() => this.open(item), 100);
        };

        onMouseLeave = (event) => {
          if (!this.hoverable) return;
          clearTimeout(this.openTimer);
          const item = event.currentTarget;
          this.closeTimer = setTimeout(() => this.close(item), 150);
        };

        onClick = (event) => {
          const toggle = event.target.closest('.nc-menu__toggle');
          if (toggle) {
            const item = toggle.closest('[data-menu-item]');
            if (toggle.getAttribute('aria-expanded') === 'true') this.close(item);
            else this.open(item);
            return;
          }

          const cartLink = event.target.closest('[data-cart-open]');
          if (cartLink && document.querySelector('nc-cart-drawer')) {
            event.preventDefault();
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        };

        onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };

        onKeydown = (event) => {
          if (event.key !== 'Escape') return;
          const item = event.target.closest('[data-menu-item]');
          const open = item ? this.toggleOf(item) : this.querySelector('.nc-menu__toggle[aria-expanded="true"]');
          if (!open || open.getAttribute('aria-expanded') !== 'true') return;
          this.close(open.closest('[data-menu-item]'));
          open.focus();
        };

        onFocusOut = (event) => {
          const item = event.target.closest('[data-menu-item]');
          if (item && !item.contains(event.relatedTarget)) this.close(item);
        };

        onBreakpoint = (event) => {
          if (event.matches) this.menuDrawer?.close();
        };

        get menuDrawer() {
          return document.querySelector('nc-drawer[id^="menu-drawer-"]');
        }

        onBlockSelect = (event) => {
          const item = event.target.closest('[data-menu-item]');
          if (item) this.open(item);
        };

        onCartUpdated = (event) => {
          const count = event.detail?.cart?.item_count;
          if (count === undefined) return;
          for (const el of this.querySelectorAll('[data-cart-count]')) {
            el.textContent = count;
            el.hidden = count === 0;
          }
        };

        onScroll = () => {
          if (this.ticking || this.dataset.sticky !== 'scroll_up') return;
          this.ticking = true;
          requestAnimationFrame(() => {
            const y = Math.max(window.scrollY, 0);
            const hide =
              y > this.lastY &&
              y > this.offsetHeight &&
              !this.contains(document.activeElement) &&
              !this.querySelector('.nc-menu__toggle[aria-expanded="true"]');
            if (hide) {
              this.closeAll();
              this.wrapper?.classList.add('is-header-hidden');
            } else if (y < this.lastY) {
              this.wrapper?.classList.remove('is-header-hidden');
            }
            this.lastY = y;
            this.ticking = false;
          });
        };
      },
    );
  }

  if (!window.ncWishlistCounter) {
    window.ncWishlistCounter = true;
    const updateWishlistCount = () => {
      let count = 0;
      try {
        const list = JSON.parse(localStorage.getItem('nc:wishlist'));
        if (Array.isArray(list)) count = list.length;
      } catch (error) {
        count = 0;
      }
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    };
    updateWishlistCount();
    document.addEventListener('wishlist:updated', updateWishlistCount);
    window.addEventListener('storage', (event) => {
      if (event.key === 'nc:wishlist' || event.key === null) updateWishlistCount();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-toolbar"]) return;
  try {
    
  if (!customElements.get('nc-mobile-toolbar')) {
    customElements.define(
      'nc-mobile-toolbar',
      class extends HTMLElement {
        connectedCallback() {
          this.query = window.matchMedia('(max-width: 767px)');
          this.nav = this.querySelector('nav');
          this.onClick = (event) => {
            const cartLink = event.target.closest('[data-cart-open]');
            if (cartLink && document.querySelector('nc-cart-drawer')) {
              event.preventDefault();
              document.dispatchEvent(new CustomEvent('cart:open'));
            }
          };
          this.measure = () => {
            const active = this.query.matches && !this.classList.contains('nc-mobile-toolbar--off');
            const height = active ? this.getBoundingClientRect().height : 0;
            document.documentElement.style.setProperty('--mobile-toolbar-height', `${Math.ceil(height)}px`);
          };
          this.onCartUpdated = (event) => {
            const count = event.detail && event.detail.cart ? event.detail.cart.item_count : undefined;
            if (count === undefined) return;
            this.querySelectorAll('[data-cart-count]').forEach((el) => {
              el.textContent = count;
              el.hidden = count === 0;
            });
          };
          document.addEventListener('cart:updated', this.onCartUpdated);
          this.observer = new ResizeObserver(this.measure);
          this.observer.observe(this);
          this.query.addEventListener('change', this.measure);
          this.addEventListener('click', this.onClick);
          this.markCurrent();
          this.measure();
        }

        disconnectedCallback() {
          this.observer.disconnect();
          this.query.removeEventListener('change', this.measure);
          this.removeEventListener('click', this.onClick);
          document.removeEventListener('cart:updated', this.onCartUpdated);
          document.documentElement.style.removeProperty('--mobile-toolbar-height');
        }

        markCurrent() {
          const path = window.location.pathname;
          this.querySelectorAll('a.nc-mobile-toolbar__item').forEach((link) => {
            const url = new URL(link.href, window.location.origin);
            const match = url.pathname === path && !link.hasAttribute('data-search-open');
            if (match) link.setAttribute('aria-current', 'page');
          });
        }
      },
    );
  }

  if (!window.ncWishlistCounter) {
    window.ncWishlistCounter = true;
    const updateWishlistCount = () => {
      let count = 0;
      try {
        const list = JSON.parse(localStorage.getItem('nc:wishlist'));
        if (Array.isArray(list)) count = list.length;
      } catch (error) {
        count = 0;
      }
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    };
    updateWishlistCount();
    document.addEventListener('wishlist:updated', updateWishlistCount);
    window.addEventListener('storage', (event) => {
      if (event.key === 'nc:wishlist' || event.key === null) updateWishlistCount();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nc-password__details').forEach((details) => {
    if (details.querySelector('[data-password-error]')) details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-product-gallery')) {
    customElements.define(
      'nc-product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.stage = this.querySelector('.nc-gallery-main__stage');
          this.slides = Array.from(this.querySelectorAll('.nc-gallery-main__slide'));
          this.thumbs = Array.from(this.querySelectorAll('.nc-gallery-main__thumb'));
          this.dots = Array.from(this.querySelectorAll('.nc-dot'));
          this.zoomButton = this.querySelector('.nc-gallery-main__zoom');
          this.zoomDialog = this.querySelector('.nc-gallery-main__zoom-dialog');
          this.zoomImage = this.zoomDialog ? this.zoomDialog.querySelector('img') : null;

          this.onTargetClick = this.onTargetClick.bind(this);
          this.onScroll = this.onScroll.bind(this);
          this.onVariantChanged = this.onVariantChanged.bind(this);

          this.thumbs.concat(this.dots).forEach((control) => control.addEventListener('click', this.onTargetClick));
          if (this.stage) this.stage.addEventListener('scroll', this.onScroll, { passive: true });

          if (this.zoomButton && this.zoomDialog) {
            this.zoomButton.addEventListener('click', () => this.openZoom());
            this.zoomDialog.addEventListener('click', (event) => {
              if (event.target === this.zoomDialog || event.target.closest('.nc-gallery-main__zoom-close')) {
                this.zoomDialog.close();
              }
            });
          }

          document.addEventListener('variant:changed', this.onVariantChanged);
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          document.removeEventListener('variant:changed', this.onVariantChanged);
        }

        onTargetClick(event) {
          this.goTo(event.currentTarget.dataset.target);
        }

        goTo(id) {
          const slide = this.slides.find((candidate) => candidate.id === id);
          if (!slide || !this.stage) return;
          this.stage.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          this.setActive(slide);
        }

        setActive(slide) {
          this.slides.forEach((candidate) => candidate.classList.toggle('is-active', candidate === slide));
          this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.target === slide.id));
          this.dots.forEach((dot) => dot.classList.toggle('is-active', dot.dataset.target === slide.id));
        }

        onScroll() {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (!this.stage) return;
            const current = this.slides.find(
              (slide) => Math.abs(slide.offsetLeft - this.stage.scrollLeft) < slide.offsetWidth / 2,
            );
            if (current) this.setActive(current);
          });
        }

        openZoom() {
          const active = this.slides.find((slide) => slide.classList.contains('is-active'));
          const src = active ? active.dataset.zoomSrc : null;
          if (!src || !this.zoomDialog || !this.zoomImage) return;
          this.zoomImage.src = src;
          this.zoomDialog.showModal();
        }

        onVariantChanged(event) {
          const mediaId =
            event.detail && event.detail.variant && event.detail.variant.featured_media
              ? event.detail.variant.featured_media.id
              : null;
          if (!mediaId) return;
          this.goTo(this.sectionId + '-media-' + mediaId);
        }
      },
    );
  }

  if (!customElements.get('nc-sticky-atc')) {
    customElements.define(
      'nc-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          this.target = document.querySelector(this.dataset.watch);
          this.submitButton = this.querySelector('[data-sticky-atc-submit]');

          this.onClick = () => {
            if (this.target) this.target.click();
          };
          if (this.submitButton) this.submitButton.addEventListener('click', this.onClick);

          this.onVariantRendered = (event) => {
            const next = event.detail.doc.querySelector('nc-sticky-atc');
            if (!next) return;
            const info = this.querySelector('.nc-sticky-atc__info');
            const nextInfo = next.querySelector('.nc-sticky-atc__info');
            if (info && nextInfo) info.innerHTML = nextInfo.innerHTML;
            const nextSubmit = next.querySelector('[data-sticky-atc-submit]');
            if (this.submitButton && nextSubmit) {
              this.submitButton.innerHTML = nextSubmit.innerHTML;
              this.submitButton.disabled = nextSubmit.disabled;
            }
          };
          document.addEventListener('variant:rendered', this.onVariantRendered);

          if (!this.target || !('IntersectionObserver' in window)) return;

          this.onIntersect = this.onIntersect.bind(this);
          this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0 });
          this.observer.observe(this.target);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.submitButton) this.submitButton.removeEventListener('click', this.onClick);
          document.removeEventListener('variant:rendered', this.onVariantRendered);
          document.documentElement.style.removeProperty('--sticky-atc-height');
        }

        onIntersect(entries) {
          const entry = entries[entries.length - 1];
          const scrolledPast = entry.isIntersecting === false && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', scrolledPast);
          const height = scrolledPast ? this.getBoundingClientRect().height : 0;
          document.documentElement.style.setProperty('--sticky-atc-height', `${Math.ceil(height)}px`);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-add"]) return;
  try {
    
  if (!customElements.get('nc-quick-add-dialog')) {
    customElements.define(
      'nc-quick-add-dialog',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.panel = this.querySelector('[data-quick-add-panel]');

          this.onClick = this.onClick.bind(this);
          this.onChange = this.onChange.bind(this);
          this.onSubmit = this.onSubmit.bind(this);

          this.addEventListener('click', this.onClick);
          this.addEventListener('change', this.onChange);
          this.addEventListener('submit', this.onSubmit);
          this.dialog.addEventListener('close', () => this.panel.replaceChildren());
        }

        async open(url) {
          this.panel.setAttribute('aria-busy', 'true');
          this.dialog.showModal();

          const fetchUrl = new URL(url, window.location.origin);
          fetchUrl.searchParams.set('section_id', 'quick-add');

          try {
            const response = await fetch(fetchUrl);
            const html = await response.text();
            const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-quick-add-panel]');
            if (next) this.panel.replaceWith(next);
            this.panel = this.querySelector('[data-quick-add-panel]');
          } finally {
            this.panel.removeAttribute('aria-busy');
          }
        }

        onClick(event) {
          if (event.target === this.dialog || event.target.closest('[data-quick-add-close]')) this.dialog.close();
        }

        onChange(event) {
          const field = event.target.closest('[data-option-position]');
          if (!field) return;
          this.selectVariant();
        }

        selectVariant() {
          const form = this.querySelector('nc-quick-add-form');
          if (!form) return;

          const script = form.querySelector('[data-variants]');
          const variants = script ? JSON.parse(script.textContent) : [];
          const fields = Array.from(form.querySelectorAll('[data-option-position]'));
          const positions = [...new Set(fields.map((field) => field.dataset.optionPosition))].sort(
            (a, b) => Number(a) - Number(b),
          );
          const selected = positions.map((position) => {
            const field = fields.find(
              (candidate) => candidate.dataset.optionPosition === position && candidate.checked,
            );
            return field ? field.value : null;
          });

          positions.forEach((position, index) => {
            const optionLabel = form.querySelector(`[data-option-label="${position}"]`);
            if (optionLabel && selected[index] !== null) optionLabel.textContent = selected[index];
          });

          const variant = variants.find((candidate) =>
            candidate.options.every((value, index) => value === selected[index]),
          );
          if (!variant) return;

          const idInput = form.querySelector('[data-quick-add-variant-id]');
          if (idInput) idInput.value = variant.id;

          this.querySelectorAll('[data-quick-add-price]').forEach((price) => {
            price.hidden = price.dataset.quickAddPrice !== String(variant.id);
          });

          const submit = form.querySelector('[data-quick-add-submit]');
          const label = form.querySelector('[data-quick-add-submit-text]');
          if (submit) submit.disabled = variant.available === false;
          if (label)
            label.textContent = variant.available === false ? form.dataset.soldOutLabel : form.dataset.addLabel;
        }

        onSubmit(event) {
          const form = event.target.closest('nc-quick-add-form');
          if (!form) return;
          event.preventDefault();
          this.addToCart(form, event.target);
        }

        async addToCart(form, formEl) {
          const submit = form.querySelector('[data-quick-add-submit]');
          const label = form.querySelector('[data-quick-add-submit-text]');
          const errorEl = form.querySelector('[data-quick-add-error]');
          const defaultLabel = label ? label.textContent : '';

          if (errorEl) {
            errorEl.hidden = true;
            errorEl.textContent = '';
          }
          submit.disabled = true;
          if (label) label.textContent = form.dataset.addingLabel;

          const formData = new FormData(formEl);
          formData.append('sections', 'cart-drawer');

          try {
            const response = await fetch(form.dataset.addUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData,
            });
            const data = await response.json();

            if (!response.ok) {
              if (errorEl) {
                errorEl.textContent = data.description || data.message || form.dataset.genericError;
                errorEl.hidden = false;
              }
              return;
            }

            const cart = await fetch(form.dataset.cartUrl).then((res) => res.json());
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sections: data.sections } }));
            document.dispatchEvent(new CustomEvent('cart:open'));
            this.dialog.close();
          } catch (error) {
            if (errorEl) {
              errorEl.textContent = form.dataset.genericError;
              errorEl.hidden = false;
            }
          } finally {
            submit.disabled = false;
            if (label) label.textContent = defaultLabel || form.dataset.addLabel;
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-slider')) {
    customElements.define(
      'nc-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.nc-slider');
          this.prevButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');

          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.sync());
          };
          this.onResize = () => this.sync();

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
          this.nextButton?.addEventListener('click', () => this.scrollByCard(1));

          this.sync();
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          window.removeEventListener('resize', this.onResize);
        }

        scrollByCard(direction) {
          const card = this.track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = (card.getBoundingClientRect().width + gap) * direction;
          this.track.scrollBy({ left: distance, behavior: 'smooth' });
        }

        sync() {
          const max = this.track.scrollWidth - this.track.clientWidth - 1;
          this.prevButton?.toggleAttribute('disabled', this.track.scrollLeft <= 0);
          this.nextButton?.toggleAttribute('disabled', this.track.scrollLeft >= max);
        }
      },
    );
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.url === undefined) return;

          this.observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.unobserve(this);
            this.loadRecommendations();
          });
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.unobserve(this);
        }

        loadRecommendations() {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const next = doc.querySelector('product-recommendations');
              const grid = next?.querySelector('[data-related-products-grid]');
              if (grid && grid.children.length > 0) {
                this.innerHTML = next.innerHTML;
                this.removeAttribute('hidden');
              } else {
                this.remove();
              }
            })
            .catch(() => this.remove());
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-modal"]) return;
  try {
    
  if (!customElements.get('nc-predictive-search')) {
    class NcPredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.input = this.querySelector('[data-input]');
        this.results = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-status]');
        this.cache = new Map();
        this.active = -1;
        this.timer = null;

        this.onDocumentClick = (event) => {
          const trigger = event.target.closest('[data-search-open]');
          if (!trigger) return;
          event.preventDefault();
          this.open();
        };
        document.addEventListener('click', this.onDocumentClick);

        this.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-search-close]')) this.close();
        });
        this.input.addEventListener('input', () => this.onInput());
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        this.results.addEventListener('keydown', (event) => this.onKeydown(event));
        this.dialog.addEventListener('close', () => this.reset());
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        clearTimeout(this.timer);
      }

      open() {
        if (!this.dialog.open) this.dialog.showModal();
        this.input.focus();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      reset() {
        clearTimeout(this.timer);
        if (this.controller) this.controller.abort();
        this.input.value = '';
        this.results.innerHTML = '';
        this.status.textContent = '';
        this.setActive(-1);
        this.input.setAttribute('aria-expanded', 'false');
      }

      onInput() {
        if (!this.hasAttribute('data-predictive')) return;
        clearTimeout(this.timer);
        const term = this.input.value.trim();
        if (!term) {
          this.results.innerHTML = '';
          this.status.textContent = '';
          this.input.setAttribute('aria-expanded', 'false');
          return;
        }
        this.timer = setTimeout(() => this.search(term), 250);
      }

      async search(term) {
        const params = new URLSearchParams({
          q: term,
          section_id: this.dataset.sectionId,
          'resources[type]': this.dataset.types,
          'resources[limit]': this.dataset.limit,
          'resources[limit_scope]': 'each',
        });
        const url = `${this.dataset.url}?${params}`;
        let html = this.cache.get(url);
        if (!html) {
          if (this.controller) this.controller.abort();
          this.controller = new AbortController();
          try {
            const response = await fetch(url, { signal: this.controller.signal });
            if (!response.ok) return;
            html = await response.text();
            this.cache.set(url, html);
          } catch (error) {
            return;
          }
        }
        if (this.input.value.trim() !== term) return;
        const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-results]');
        if (!incoming) return;
        this.results.innerHTML = incoming.innerHTML;
        const text = this.results.querySelector('[data-status-text]');
        this.status.textContent = text ? text.dataset.statusText : '';
        this.setActive(-1);
        this.input.setAttribute('aria-expanded', String(Boolean(this.results.querySelector('[data-result]'))));
      }

      items() {
        const items = Array.from(this.results.querySelectorAll('[data-result]'));
        items.forEach((item, index) => {
          if (!item.id) item.id = `search-modal-result-${index}`;
        });
        return items;
      }

      setActive(index) {
        const items = this.items();
        items.forEach((item) => item.classList.remove('is-active'));
        this.active = index;
        const current = items[index];
        if (current) {
          current.classList.add('is-active');
          current.scrollIntoView({ block: 'nearest' });
          this.input.setAttribute('aria-activedescendant', current.id || '');
        } else {
          this.input.removeAttribute('aria-activedescendant');
        }
      }

      onKeydown(event) {
        const items = this.items();
        if (!items.length) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.setActive(this.active + 1 >= items.length ? 0 : this.active + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.setActive(this.active <= 0 ? items.length - 1 : this.active - 1);
        } else if (event.key === 'Enter' && this.active >= 0) {
          event.preventDefault();
          items[this.active].click();
        } else if (event.key === 'Home' && event.target !== this.input) {
          event.preventDefault();
          this.setActive(0);
        } else if (event.key === 'End' && event.target !== this.input) {
          event.preventDefault();
          this.setActive(items.length - 1);
        }
      }
    }

    customElements.define('nc-predictive-search', NcPredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('select[data-auto-submit]');
    if (select?.form) select.form.requestSubmit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-slideshow')) {
    customElements.define(
      'nc-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.nc-hero__slides');
          this.slides = Array.from(this.track.querySelectorAll('.nc-hero__slide'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.interval = Number(this.dataset.interval) || 6000;
          this.index = 0;
          this.paused = false;
          this.selected = false;

          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.sync());
          };
          this.onEnter = () => this.pause();
          this.onLeave = () => this.resume();
          this.onVisibility = () => (document.hidden ? this.stop() : this.start());
          this.onKey = (event) => {
            if (event.key === 'ArrowLeft') this.go(this.index - 1, true);
            else if (event.key === 'ArrowRight') this.go(this.index + 1, true);
            else return;
            event.preventDefault();
          };
          this.onSelect = (event) => {
            const slide = event.target.closest('.nc-hero__slide');
            this.selected = true;
            this.stop();
            this.go(this.slides.indexOf(slide), true, true);
          };
          this.onDeselect = () => {
            this.selected = false;
            this.start();
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.addEventListener('mouseenter', this.onEnter);
          this.addEventListener('mouseleave', this.onLeave);
          this.addEventListener('focusin', this.onEnter);
          this.addEventListener('focusout', this.onLeave);
          this.addEventListener('touchstart', this.onEnter, { passive: true });
          this.addEventListener('touchend', this.onLeave, { passive: true });
          this.addEventListener('keydown', this.onKey);
          this.addEventListener('shopify:block:select', this.onSelect);
          this.addEventListener('shopify:block:deselect', this.onDeselect);
          document.addEventListener('visibilitychange', this.onVisibility);
          this.motion.addEventListener('change', this.onVisibility);

          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));

          this.sync();
          this.start();
        }

        disconnectedCallback() {
          this.stop();
          cancelAnimationFrame(this.frame);
          document.removeEventListener('visibilitychange', this.onVisibility);
          this.motion.removeEventListener('change', this.onVisibility);
        }

        get autoplay() {
          return this.hasAttribute('data-autoplay') && this.slides.length > 1;
        }

        pause() {
          this.paused = true;
          this.stop();
        }

        resume() {
          this.paused = false;
          this.start();
        }

        start() {
          this.stop();
          if (!this.autoplay || this.motion.matches || this.paused || this.selected || document.hidden) return;
          this.track.setAttribute('aria-live', 'off');
          this.timer = setInterval(() => this.go(this.index + 1), this.interval);
        }

        stop() {
          clearInterval(this.timer);
          this.track.setAttribute('aria-live', 'polite');
        }

        go(index, manual = false, instant = false) {
          if (index < 0 || !this.slides.length) index = this.slides.length - 1;
          if (index >= this.slides.length) index = 0;
          const behavior = instant || this.motion.matches ? 'auto' : 'smooth';
          this.track.scrollTo({ left: this.slides[index].offsetLeft - this.track.offsetLeft, behavior });
          if (manual) this.start();
        }

        sync() {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth) || 0;
          this.index = Math.min(Math.max(index, 0), this.slides.length - 1);
          this.slides.forEach((slide, i) => {
            const active = i === this.index;
            slide.toggleAttribute('inert', !active);
          });
          this.dots.forEach((dot, i) => {
            const active = i === this.index;
            dot.classList.toggle('is-active', active);
            if (active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-wishlist')) {
    customElements.define(
      'nc-wishlist',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-wishlist-grid]');
          this.loading = this.querySelector('[data-wishlist-loading]');
          this.empty = this.querySelector('[data-wishlist-empty]');
          this.notice = this.querySelector('[data-wishlist-notice]');
          this.template = this.querySelector('template[data-wishlist-card]');
          this.cache = new Map();
          this.addEventListener('click', this.onClick.bind(this));
          this.onUpdate = () => this.render();
          document.addEventListener('wishlist:updated', this.onUpdate);
          window.addEventListener('storage', this.onUpdate);
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:updated', this.onUpdate);
          window.removeEventListener('storage', this.onUpdate);
        }

        read() {
          try {
            const list = JSON.parse(localStorage.getItem('nc:wishlist'));
            return Array.isArray(list) ? list : [];
          } catch (error) {
            return [];
          }
        }

        onClick(event) {
          const trigger = event.target.closest('[data-wishlist-remove]');
          if (!trigger) return;
          const handle = trigger.closest('[data-handle]').dataset.handle;
          const next = this.read().filter((item) => item !== handle);
          try {
            localStorage.setItem('nc:wishlist', JSON.stringify(next));
          } catch (error) {
            return;
          }
          document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles: next } }));
        }

        async fetchProduct(handle) {
          if (!this.cache.has(handle)) {
            this.cache.set(
              handle,
              fetch(this.dataset.productsRoot + encodeURIComponent(handle) + '.js', {
                headers: { Accept: 'application/json' },
              })
                .then((response) => (response.ok ? response.json() : null))
                .catch(() => null),
            );
          }
          return this.cache.get(handle);
        }

        formatMoney(cents) {
          const format = this.dataset.moneyFormat || '';
          const fixed = (cents / 100).toFixed(2);
          const [whole, decimals] = fixed.split('.');
          const group = (value, separator) => value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
          const amounts = {
            amount: group(whole, ',') + '.' + decimals,
            amount_no_decimals: group(whole, ','),
            amount_with_comma_separator: group(whole, '.') + ',' + decimals,
            amount_no_decimals_with_comma_separator: group(whole, '.'),
            amount_with_apostrophe_separator: group(whole, "'") + '.' + decimals,
            amount_no_decimals_with_space_separator: group(whole, ' '),
            amount_with_space_separator: group(whole, ' ') + ',' + decimals,
            amount_with_period_and_space_separator: group(whole, ' ') + '.' + decimals,
          };
          return (
            format.replace(/\{\s*\{\s*(\w+)\s*\}\s*\}/g, (match, key) => (key in amounts ? amounts[key] : match)) ||
            amounts.amount
          );
        }

        buildCard(product) {
          const card = this.template.content.firstElementChild.cloneNode(true);
          card.dataset.handle = product.handle;
          const url = this.dataset.productsRoot + encodeURIComponent(product.handle);
          const link = card.querySelector('[data-card-link]');
          link.href = url;
          link.setAttribute('aria-label', product.title);
          if (product.featured_image) {
            const img = document.createElement('img');
            img.src = product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_640x$1$2');
            img.alt = '';
            img.loading = 'lazy';
            img.className = 'nc-card__img';
            link.append(img);
          }
          if (!product.available) {
            card.classList.add('nc-card--soldout');
            card.querySelector('[data-card-badges]').hidden = false;
          }
          const vendor = card.querySelector('[data-card-vendor]');
          vendor.textContent = product.vendor || '';
          vendor.hidden = !product.vendor;
          const title = card.querySelector('[data-card-title]');
          title.href = url;
          title.textContent = product.title;
          card.querySelector('[data-card-price]').textContent = this.formatMoney(product.price);
          if (product.compare_at_price > product.price) {
            const compare = card.querySelector('[data-card-compare]');
            compare.textContent = this.formatMoney(product.compare_at_price);
            compare.hidden = false;
            card.querySelector('.nc-price').classList.add('nc-price--sale');
          }
          return card;
        }

        async render() {
          const handles = this.read();
          const token = (this.token = (this.token || 0) + 1);
          this.notice.hidden = true;

          if (handles.length === 0) {
            this.loading.hidden = true;
            this.grid.hidden = true;
            this.grid.replaceChildren();
            this.empty.hidden = false;
            return;
          }

          this.empty.hidden = true;
          if (this.grid.children.length === 0) this.loading.hidden = false;

          const products = await Promise.all(handles.map((handle) => this.fetchProduct(handle)));
          if (token !== this.token) return;

          const cards = products.filter(Boolean).map((product) => this.buildCard(product));
          this.loading.hidden = true;
          this.grid.replaceChildren(...cards);
          this.grid.hidden = cards.length === 0;
          this.empty.hidden = cards.length > 0;
          if (cards.length < handles.length) {
            this.notice.textContent = this.dataset.unavailable;
            this.notice.hidden = false;
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
